import { Avatar, Card, Progress } from "antd";
import { useAppSelector } from "../../../../app/store";
import PLACEHOLDER_IMG from "../../../../assets/images/avatar.svg";
import colors from "../../../../constants/colors";
import { GetDashboardDataResponse } from "../../../../features/organization/dashboard/dashboard.type";

type Props = {
  data?: GetDashboardDataResponse;
};

const UserProfile = ({ data }: Props) => {
  const { user } = useAppSelector((state) => state.auth);
  const hireRatio = data?.overview?.hireRatioPercentage || 0;

  return (
    <Card className="rounded-lg shadow-sm items-center gap-4 bg-white mb-6">
      {/* Left Section: Avatar + Name + Location */}
      <div className="w-full grid md:grid-cols-5 items-center gap-6 ">
        <div className="flex items-center gap-4 flex-1 md:col-span-2">
          <div className="relative">
            <Avatar size={64} src={user?.profile?.pro_pic || PLACEHOLDER_IMG} />
            {/* Online Indicator */}
            {/* <span className="absolute top-1 left-1 bg-green-500 border-2 border-white rounded-full w-3 h-3"></span> */}
            {/* <button className="absolute -bottom-1 -right-1 bg-white border-2 border-[#1B4DFF] rounded-full h-6 w-6 flex items-center justify-center">
              <EditIcon />
            </button> */}
          </div>

          <div className="flex flex-col space-y-1">
            <div className="flex items-center gap-2">
              <h2 className="font-semibold text-lg text-[#1C222B] text-nowrap">
                {user?.name}
              </h2>
              {/* <Tag
                icon={<ChecksIcon />}
                className="text-xs px-1.5 py-0.5 bg-status-success-bg text-status-success-text rounded-full flex items-center gap-1.5"
              >
                Verified
              </Tag> */}
            </div>
            <p className="text-display-body text-sm flex items-center gap-1.5">
              {/* <LocationIcon /> */}
              {user?.email}
            </p>

            {/* Rating */}
            {/* <div className="flex items-center gap-2">
              <Rate
                disabled
                allowHalf
                defaultValue={0}
                className="text-orange-400"
              />
              <span className="font-medium text-[#2D3643] text-base font-roboto">
                0
              </span>
              <span className="text-display-body text-sm">(0)</span>
            </div> */}
          </div>
        </div>

        {/* Right Section: Stats */}
        <div className="w-full md:col-span-3 text-base text-gray-700 relative after:absolute after:top-0 after:-left-24 after:w-[1.5px] after:h-full after:bg-[#AFBACA]">
          {/* <div className="flex flex-col gap-1">
            <span className="text-title text-base">Inbox Response Rate</span>
            <div className="flex items-center gap-3">
              <Progress
                percent={80}
                showInfo={false}
                strokeColor={colors.success.color}
                className="w-32"
              />
              <span className="text-title font-medium">80%</span>
            </div>
          </div> */}

          {/* <div className="flex flex-col gap-1">
            <span className="text-title text-base">Inbox Response Time</span>
            <span className="text-status-success-text font-medium">1 Hr</span>
          </div> */}

          <div className="flex flex-col gap-1">
            <span className="text-title">Hire Ratio</span>
            <div className="flex items-center gap-3">
              <Progress
                percent={hireRatio}
                showInfo={false}
                strokeColor={colors.success.color}
                className="w-32"
              />
              <span className="text-title font-medium">{hireRatio}%</span>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default UserProfile;
